import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('BugReportsOpenCountResponse')
export class BugReportsOpenCountResponse {

  @JsonProperty('open_count', Number)
  openCount: number = 0;
}
